import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  ButtonProps,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuProps,
} from '@mui/material';
import { FC, useState, JSX, SyntheticEvent } from 'react';

export interface IMenuItem {
  name: string;
  icon?: JSX.Element;
  onClick: (e?: SyntheticEvent) => void;
  disabled?: boolean;
  hide?: boolean;
  divider?: boolean;
  title?: string;
}
interface MenuButtonProps {
  renderButton?: (props: ButtonProps) => JSX.Element;
  menuItems: IMenuItem[];
  label?: string;
  menuProps?: Omit<MenuProps, 'open'>;
  disabled?: boolean;
}

export const MenuButton: FC<MenuButtonProps> = ({ menuItems, label, renderButton, menuProps, disabled }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const open = Boolean(anchor);

  const handleItemClick = (item: IMenuItem) => {
    setAnchor(null);
    item.onClick();
  };

  const button = renderButton ? (
    renderButton({ onClick: (e) => setAnchor(e.currentTarget), title: label })
  ) : (
    <IconButton onClick={(e) => setAnchor(e.currentTarget)} title={label} disabled={disabled}>
      <MoreVertIcon color={disabled ? 'disabled' : 'secondary'} />
    </IconButton>
  );

  return (
    <>
      {button}
      <Menu
        anchorEl={anchor}
        open={open}
        onClose={() => setAnchor(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        {...menuProps}
      >
        {open &&
          menuItems.map((item) => {
            if (item.hide) {
              return null;
            }
            return (
              <div key={item.name} title={item.title}>
                <MenuItem
                  onClick={() => handleItemClick(item)}
                  disabled={item.disabled}
                  divider={item.divider}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>{item.name}</ListItemText>
                </MenuItem>
              </div>
            );
          })}
      </Menu>
    </>
  );
};
